/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

import Hello from "@/components/Hello";
import EditUser from "@/components/editUser";
import Login from "@/components/login";
import SignUp from "@/components/signup";
import Admin from "@/components/admin";
import Helferuebersicht from "@/components/helferuebersicht";
import BasicSettings from "@/components/basicSettings";
import firebase from "firebase";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresAuth: false,
        requiresAdmin: false
      }
    },
    {
      path: "/sign-up",
      name: "SignUp",
      component: SignUp,
      meta: {
        requiresAuth: false,
        requiresAdmin: false
      }
    },
    {
      path: "/hello",
      name: "Hello",
      component: Hello,
      meta: {
        requiresAuth: true,
        requiresAdmin: false
      }
    },
    {
      path: "/editUser",
      name: "EditUser",
      component: EditUser,
      meta: {
        requiresAuth: true,
        requiresAdmin: false
      }
    },
    {
      path: "/helferuebersicht",
      name: "Helferuebersicht",
      component: Helferuebersicht,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },

    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: "/basicSettings",
      name: "BasicSettings",
      component: BasicSettings,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   let currentUser = firebase.auth().currentUser;

//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//   if (requiresAuth && !currentUser) next("login");
//   else if (!requiresAuth && currentUser) next("hello");
//   else next();
// });

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

  if (requiresAuth && !currentUser) next("login");
  else if (requiresAdmin) {
    firebase
      .firestore()
      .collection("users")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then(function(doc) {
        //console.log(doc.data().admin)
        if (doc.data().admin) {
          next();
        } else next("hello");
      });
  } else next();
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth) {
//     const currentUser = firebase.auth().currentUser;
//     if (!currentUser) {
//       next("login");
//     } else if (to.meta.adminAuth) {
//       const isAdmin = false;

//       if (isAdmin) {
//         next();
//       } else next("hello");
//     } else next();
//   }
// });

// router.beforeEach((to, from, next) => {
//   let currentUser = firebase.auth().currentUser;
//   let isAdmin = true;
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//   let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
//   if (requiresAuth && !currentUser) next("login");
//   else if (requiresAuth && currentUser) next("hello");
//   else if (requiresAuth && requiresAdmin && currentUser && isAdmin) next();
//   else if (requiresAuth && requiresAdmin && currentUser && !isAdmin)
//     next("hello");
//   else next();
// });

export default router;
